// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3q6sH","footer":"ReportModalFilter_footer__1oZzo"};